import React from 'react';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import CableOutlinedIcon from '@mui/icons-material/CableOutlined';
import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';

import navChat        from '../../assets/logos/nav/nav-chat.svg';
import navCollaborate from '../../assets/logos/nav/nav-collaborate.svg';
import navAgents      from '../../assets/logos/nav/nav-agents.png';

export interface NavTab {
  key: string;
  label: string;
  icon: React.ReactNode;
  index: number;
  enabled: boolean;
}

/**
 * `label` is intentionally not used as alt text. Every tab renders its label as
 * visible text next to the icon, so alt={label} made the button announce the
 * name twice ("Chat Chat") and tripped axe's image-redundant-alt. The icon is
 * decorative; the adjacent text carries the name.
 */
export const navImg = (src: string, label: string, style?: React.CSSProperties): React.ReactNode => (
  <img src={src} alt="" width={32} height={32} style={{ objectFit: 'contain', ...style }} />
);

const muiIcon = (Icon: React.ElementType): React.ReactNode => (
  <Icon sx={{ fontSize: 28, color: '#ffffff' }} />
);

/** Track 1 — Chat screen */
export const CHAT_TABS: NavTab[] = [
  { key: 'chat',        label: 'Chat',          icon: navImg(navChat,        'Chat'),          index: 0, enabled: true  },
  { key: 'collaborate', label: 'Collaborate',   icon: navImg(navCollaborate, 'Collaborate'),   index: 1, enabled: true  },
  { key: 'agents',      label: 'Agents & Apps', icon: navImg(navAgents,      'Agents & Apps', { filter: 'brightness(0) invert(1)' }), index: 2, enabled: true },
];

/** Track 2 — Apps / agentic screens */
export const APPS_TABS: NavTab[] = [
  { key: 'chat',       label: 'Chat',          icon: navImg(navChat,   'Chat'),          index: 0, enabled: true  },
  { key: 'agents',     label: 'Agents & Apps', icon: navImg(navAgents, 'Agents & Apps', { filter: 'brightness(0) invert(1)' }), index: 1, enabled: true  },
  { key: 'analytics',  label: 'Analytics',     icon: muiIcon(BarChartOutlinedIcon),      index: 2, enabled: false },
  { key: 'connectors', label: 'Connectors',    icon: muiIcon(CableOutlinedIcon),         index: 3, enabled: false },
  { key: 'monitor',    label: 'Monitor',       icon: muiIcon(MonitorHeartOutlinedIcon),  index: 4, enabled: false },
];
